// History subsection questionnaire constants
export enum HistoryQuestionnaireItem {
  MEDICAL_BACKGROUND_HISTORY = 'medical-background/history',
  MEDICAL_BACKGROUND_HISTORY_FUNCTIONAL_LIMITATIONS = 'medical-background/history/functional-limitations',
  MEDICAL_BACKGROUND_HISTORY_ACTIVITIES_PERMITTED = 'medical-background/history/activities-permitted',
  MEDICAL_BACKGROUND_HISTORY_MEDICAL_HISTORY = 'medical-background/history/medical-history',
  MEDICAL_BACKGROUND_HISTORY_SURGICAL_HISTORY = 'medical-background/history/surgical-history'
}
